import { all, call, put, takeLatest } from 'redux-saga/effects'

import request from '../../api/api'
import { setFilterParams } from '../../helpers/setFilterParams'
import { FetchLayoutsFailure, FetchLayoutsSuccess } from './actions'
import { FETCH_LAYOUTS_REQUEST } from './actionTypes'

function* fetchLayoutstSagas({ payload, id }: any): any {
  try {
    // console.log(setFilterParams(`?project=${id}`))
    const response = yield call(
      request.get,
      `flats/${setFilterParams(`?project=${id}`)}`,
      payload
    )

    yield put(
      FetchLayoutsSuccess({
        project: response.data,
      })
    )
  } catch (e: any) {
    yield put(
      FetchLayoutsFailure({
        error: e.statusText,
      })
    )
  }
}

function* layoutsSaga() {
  yield all([takeLatest(FETCH_LAYOUTS_REQUEST, fetchLayoutstSagas)])
}

export default layoutsSaga
